export default __webpack_public_path__ + "static/media/MASPA.775d8c64.jpg";